export var VariableType;
(function (VariableType) {
    VariableType["TABLE_MAPPING"] = "TABLE_MAPPING";
    VariableType["CONNECTION_PROPERTY"] = "CONNECTION_PROPERTY";
    VariableType["CONNECTION_PROPERTY_PER_PRINCIPAL"] = "CONNECTION_PROPERTY_PER_PRINCIPAL";
    VariableType["TIME_ZONE"] = "TIME_ZONE";
    VariableType["CURRENCY"] = "CURRENCY";
    VariableType["LOCALE"] = "LOCALE";
    VariableType["FORMULA"] = "FORMULA_VARIABLE";
    VariableType["USER_PROPERTY"] = "USER_PROPERTY";
})(VariableType || (VariableType = {}));
export const PRIMARY_ORG_ID = '0';
export var VariableSortField;
(function (VariableSortField) {
    VariableSortField["NAME"] = "NAME";
    VariableSortField["TYPE"] = "TYPE";
    VariableSortField["CREATED"] = "CREATED";
    VariableSortField["VALUES_ASSIGNED"] = "VALUES_ASSIGNED";
    VariableSortField["OWNER_ORG_NAME"] = "OWNER_ORG_NAME";
})(VariableSortField || (VariableSortField = {}));
export var TranslationsKeys;
(function (TranslationsKeys) {
    TranslationsKeys["PAGE_TITLE"] = "variables.page.title";
    TranslationsKeys["PAGE_DESCRIPTION"] = "variables.page.description";
    TranslationsKeys["CREATE_BUTTON"] = "variables.create.button";
    TranslationsKeys["EDIT_VARIABLE"] = "variables.edit.title";
    TranslationsKeys["DELETE_VARIABLE"] = "variables.delete.title";
    TranslationsKeys["SEARCH_PLACEHOLDER"] = "variables.search.placeholder";
    TranslationsKeys["TABLE_HEADER_NAME"] = "variables.table.name";
    TranslationsKeys["TABLE_HEADER_TYPE"] = "variables.table.type";
    TranslationsKeys["TABLE_HEADER_SENSITIVE"] = "variables.table.sensitive";
    TranslationsKeys["TABLE_HEADER_VALUES"] = "variables.table.values";
    TranslationsKeys["TABLE_HEADER_ACTIONS"] = "variables.table.actions";
    TranslationsKeys["TABLE_HEADER_CREATEDIN"] = "variables.table.createdin";
    TranslationsKeys["MODAL_CREATE_TITLE"] = "variables.modal.create.title";
    TranslationsKeys["MODAL_EDIT_TITLE"] = "variables.modal.edit.title";
    TranslationsKeys["MODAL_DELETE_TITLE"] = "variables.modal.delete.title";
    TranslationsKeys["MODAL_DELETE_MESSAGE"] = "variables.modal.delete.message";
    TranslationsKeys["MODAL_DELETE_MULTI_MESSAGE"] = "variables.modal.delete.multi.message";
    TranslationsKeys["MODAL_RENAME_TITLE"] = "variables.modal.rename.title";
    TranslationsKeys["MODAL_RENAME_MESSAGE"] = "variables.modal.rename.message";
    TranslationsKeys["FIELD_NAME"] = "variables.field.name";
    TranslationsKeys["FIELD_TYPE"] = "variables.field.type";
    TranslationsKeys["FIELD_TYPE_LABEL"] = "variables.field.label.type";
    TranslationsKeys["FIELD_SENSITIVE"] = "variables.field.sensitive";
    TranslationsKeys["FIELD_SENSITIVE_LABEL"] = "variables.field.label.sensitive";
    TranslationsKeys["FIELD_DEFAULT_VALUE"] = "variables.field.default.value";
    TranslationsKeys["VALIDATION_NAME_REQUIRED"] = "variables.validation.name.required";
    TranslationsKeys["VALIDATION_NAME_INVALID"] = "variables.validation.name.invalid";
    TranslationsKeys["VALIDATION_NAME_MAX_LENGTH"] = "variables.validation.name.max.length";
    TranslationsKeys["SUCCESS_CREATE"] = "variables.success.create";
    TranslationsKeys["SUCCESS_UPDATE"] = "variables.success.update";
    TranslationsKeys["SUCCESS_DELETE_SINGLE"] = "variables.success.delete.single";
    TranslationsKeys["SUCCESS_DELETE_MULTI"] = "variables.success.delete.multi";
    TranslationsKeys["ERROR_CREATE"] = "variables.error.create";
    TranslationsKeys["ERROR_UPDATE"] = "variables.error.update";
    TranslationsKeys["ERROR_DELETE"] = "variables.error.delete";
    TranslationsKeys["ERROR_DELETE_NETWORK"] = "variables.error.deleteNetwork";
    TranslationsKeys["ERROR_DELETE_API"] = "variables.error.deleteApi";
    TranslationsKeys["ERROR_DELETE_DEPENDENT_OBJECTS"] = "variables.error.deleteDependentObjects";
    TranslationsKeys["ERROR_FETCH"] = "variables.error.fetch";
    TranslationsKeys["ERROR_NAME_EXISTS"] = "variables.error.name.exists";
    TranslationsKeys["DEPENDENTS_MODAL_TITLE"] = "variables.dependents.modal.title";
    TranslationsKeys["DEPENDENTS_MODAL_MESSAGE"] = "variables.dependents.modal.message";
    TranslationsKeys["VIEW_DEPENDENTS_BUTTON"] = "variables.viewDependents.button";
    TranslationsKeys["ACTION_EDIT"] = "variables.action.edit";
    TranslationsKeys["ACTION_RENAME"] = "variables.action.rename";
    TranslationsKeys["ACTION_DELETE"] = "variables.action.delete";
    TranslationsKeys["ACTION_MORE_OPTIONS"] = "variables.action.more.options";
    TranslationsKeys["SAVE"] = "Save";
    TranslationsKeys["CANCEL"] = "Cancel";
    TranslationsKeys["CREATE"] = "Create";
    TranslationsKeys["BACK"] = "Back";
    TranslationsKeys["NEXT"] = "NEXT";
    TranslationsKeys["NO_VARIABLES"] = "variables.empty.title";
    TranslationsKeys["NO_VARIABLES_DESC"] = "variables.empty.description";
    TranslationsKeys["NO_MATCH"] = "variables.no.match";
    TranslationsKeys["SELECTED_COUNT_SINGLE"] = "variables.selection.count.single";
    TranslationsKeys["SELECTED_COUNT_MULTIPLE"] = "variables.selection.count.multiple";
    TranslationsKeys["FORMULA_HINT"] = "variables.formula.hint";
    TranslationsKeys["ADD_ROW_BUTTON"] = "variables.addRowButton";
    TranslationsKeys["VALUE_LABEL"] = "variables.value.label";
    TranslationsKeys["ORG_MAPPING_LABEL"] = "variables.orgMapping.label";
    TranslationsKeys["ORG_MAPPING_HEADER_LABEL"] = "variables.orgMapping.headerLabel";
    TranslationsKeys["ORG_MAPPING_PLACEHOLDER"] = "variables.orgMapping.placeholder";
    TranslationsKeys["ORG_MAPPING_VALUE_PLACEHOLDER"] = "variables.orgMapping.value.placeholder";
    TranslationsKeys["PURPOSE_LABEL"] = "variables.purpose.label";
    TranslationsKeys["PURPOSE_TABLE_MAPPING"] = "variables.purpose.tableMapping";
    TranslationsKeys["PURPOSE_CONNECTION_PROPERTY"] = "variables.purpose.connectionProperty";
    TranslationsKeys["PURPOSE_CONNECTION_PROPERTY_PER_PRINCIPAL"] = "variables.purpose.connectionPropertyPerPrincipal";
    TranslationsKeys["PURPOSE_FORMULA"] = "variables.purpose.formula";
    TranslationsKeys["ASSIGN_VALUES"] = "variables.assignValues";
    TranslationsKeys["ADD_DETAILS"] = "variables.addDetails";
    TranslationsKeys["TOOLTIP_ORG_MAPPING"] = "variables.orgMapping.tooltip";
    TranslationsKeys["ORG_MAPPING_VALIDATION_ERROR_MISSING_VALUES"] = "variables.orgMapping.validation.error.missingValues";
    TranslationsKeys["ORG_MAPPING_VALIDATION_ERROR_MISSING_ORGS"] = "variables.orgMapping.validation.error.missingOrgs";
    TranslationsKeys["ORG_MAPPING_VALIDATION_ERROR_MISSING_BOTH"] = "variables.orgMapping.validation.error.missingBoth";
    TranslationsKeys["ORG_MAPPING_VALIDATION_ERROR_INVALID_TIMEZONE"] = "variables.orgMapping.validation.error.invalidTimezone";
})(TranslationsKeys || (TranslationsKeys = {}));
export var ListActionType;
(function (ListActionType) {
    ListActionType["EDIT"] = "EDIT";
    ListActionType["RENAME"] = "RENAME";
    ListActionType["DELETE"] = "DELETE";
    ListActionType["VIEW_ASSIGNMENTS"] = "VIEW_ASSIGNMENTS";
    ListActionType["DUPLICATE"] = "DUPLICATE";
})(ListActionType || (ListActionType = {}));
export var MODE;
(function (MODE) {
    MODE["ADD"] = "ADD";
    MODE["EDIT"] = "EDIT";
    MODE["RENAME"] = "RENAME";
    MODE["DELETE"] = "DELETE";
    MODE["DELETE_MULTI"] = "DELETE_MULTI";
})(MODE || (MODE = {}));
export var TableColumnHeaders;
(function (TableColumnHeaders) {
    TableColumnHeaders["NAME"] = "name";
    TableColumnHeaders["TYPE"] = "variable_type";
    TableColumnHeaders["SENSITIVE"] = "sensitive";
    TableColumnHeaders["VALUES_ASSIGNED"] = "valuesCount";
    TableColumnHeaders["MORE_OPTION"] = "moreOption";
    TableColumnHeaders["OWNER_ORG_NAME"] = "owner_org_name";
})(TableColumnHeaders || (TableColumnHeaders = {}));
export const VARIABLE_TYPE_OPTIONS = [
    {
        label: 'Table Mapping',
        value: VariableType.TABLE_MAPPING,
    },
    {
        label: 'Connection Property',
        value: VariableType.CONNECTION_PROPERTY,
    },
    {
        label: 'Time Zone',
        value: VariableType.TIME_ZONE,
    },
    {
        label: 'Currency',
        value: VariableType.CURRENCY,
    },
    {
        label: 'Locale',
        value: VariableType.LOCALE,
    },
    {
        label: 'Formula',
        value: VariableType.FORMULA,
    },
];
export const DEFAULT_PAGINATION_BATCHSIZE = 20;
export const defaultVariableParams = {
    offset: 0,
    batchSize: DEFAULT_PAGINATION_BATCHSIZE,
    sort: VariableSortField.NAME,
    sortAscending: true,
    pattern: '',
    skipIds: [],
};
export const sortKeyMap = {
    [TableColumnHeaders.NAME]: VariableSortField.NAME,
    [TableColumnHeaders.TYPE]: VariableSortField.TYPE,
    [TableColumnHeaders.VALUES_ASSIGNED]: VariableSortField.VALUES_ASSIGNED,
    [TableColumnHeaders.SENSITIVE]: VariableSortField.NAME,
    [TableColumnHeaders.MORE_OPTION]: VariableSortField.NAME,
    [TableColumnHeaders.OWNER_ORG_NAME]: VariableSortField.OWNER_ORG_NAME,
};
export const COMMON_ERROR_CODE = 10000;
export const VARIABLE_NAME_EXISTS_ERROR_CODE = 10452;
//# sourceMappingURL=variable-interface.js.map